//if the input sportEventId contains the 'm:' prefix, then remove it and return as an integer
export function denormalizeSportEventId(sportEventId) {
    if (typeof sportEventId === 'number') {
        return sportEventId;
    }
    return parseInt(sportEventId, 10);
}

//method prefixes the input `sportEventId` with `m:` if necessary
//if the input is falsy, then it returns null
export function normalizeSportEventId(sportEventId) {
    if (!sportEventId) {
        return null;
    }

    if (typeof sportEventId === 'string' && sportEventId.charAt(0) === 'm') {
        return sportEventId.slice(2);
    }

    return '' + sportEventId;
}

//method prefixes the input `betId` with `urn:be:bet:` if necessary
//if the input is falsy, then it returns null
export function normalizeBetId(betId) {
    if (!betId) {
        return null;
    }

    //this is not the most robust test, but until proven otherwise it should be sufficient
    // if (typeof betId === 'string' && betId.charAt(0) === 'u') {
    //     return betId;
    // }
    if (typeof betId === 'string' && betId.startsWith('urn:be:bet:')) {
        return betId.slice(11);
    }

    return '' + betId;
}

//if the input tournamentId contains the 't:' prefix, then remove it and return as an integer
export function denormalizeTournamentId(tournamentId) {
    if (!tournamentId) {
        return null;
    }

    if (typeof tournamentId === 'number') {
        return tournamentId;
    }

    //assuming that the input is string
    const denormalized = tournamentId.startsWith('t:') ? tournamentId.slice(2) : tournamentId;

    return parseInt(denormalized, 10);
}

//method prefixes the input `tournamentId` with `t:` if necessary
//if the input is falsy, then it returns null
export function normalizeTournamentId(tournamentId) {
    if (!tournamentId) {
        return null;
    }

    //this is not the most robust test, but until proven otherwise it should be sufficient
    // if (typeof tournamentId === 'string' && tournamentId.charAt(0) === 't') {
    //     return tournamentId;
    // }
    if (typeof tournamentId === 'string' && tournamentId.startsWith('t:')) {
        return tournamentId.slice(2);
    }

    return '' + tournamentId;
}

export function normalizeLiveSelection(liveSelection) {
    return String(liveSelection?.charCodeAt(0));
}
